"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionsListStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var commons_1 = require("../../../../style/commons");
exports.useActionsListStyles = (0, styles_1.makeStyles)(function () { return ({
    actionsList: {
        minWidth: 200,
        borderRadius: 4,
        boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.08)',
        overflow: 'hidden',
        zIndex: 1,
    },
    action: {
        height: 48,
        width: '100%',
        padding: '0 16px',
        backgroundColor: commons_1.white,
        color: commons_1.darkSecondary,
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        cursor: 'pointer',
        '&$actionSelected, &$actionSelected:hover': {
            backgroundColor: commons_1.secondaryColor,
        },
        '&:hover': {
            backgroundColor: commons_1.secondaryHover,
        },
        '& > span': {
            display: 'flex',
            width: '100%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            color: commons_1.darkSecondary,
        },
    },
    actionSelected: {},
    error: {
        color: commons_1.mediumRed,
    },
    warning: {
        color: commons_1.mediumYellow,
    },
    info: {
        color: commons_1.mediumTurquoise,
    },
}); });
